import type { DocumentUploadState } from '@/types/document-upload.type';

// Primitive selectors - subscribe to individual state slices
export const selectDocumentType = (state: DocumentUploadState) => state.documentType;

export const selectUploadedFile = (state: DocumentUploadState) => state.uploadedFile;

export const selectIsDragOver = (state: DocumentUploadState) => state.isDragOver;

export const selectValidationErrors = (state: DocumentUploadState) => state.validationErrors;

export const selectWebPageUrl = (state: DocumentUploadState) => state.webPageUrl;

export const selectWebPageError = (state: DocumentUploadState) => state.webPageError;

export const selectTextName = (state: DocumentUploadState) => state.textName;

export const selectTextContent = (state: DocumentUploadState) => state.textContent;

export const selectTextError = (state: DocumentUploadState) => state.textError;

// Compound selectors - combine related state for specific components
export const selectFileUploadState = (state: DocumentUploadState) => ({
  uploadedFile: state.uploadedFile,
  isDragOver: state.isDragOver,
  validationErrors: state.validationErrors,
});

export const selectUrlUploadState = (state: DocumentUploadState) => ({
  webPageUrl: state.webPageUrl,
  webPageError: state.webPageError,
});

export const selectTextUploadState = (state: DocumentUploadState) => ({
  textName: state.textName,
  textContent: state.textContent,
  textError: state.textError,
});

// Selector for form validation state
export const selectFormValidationState = (state: DocumentUploadState) => ({
  documentType: state.documentType,
  uploadedFile: state.uploadedFile,
  webPageUrl: state.webPageUrl,
  textName: state.textName,
  textContent: state.textContent,
});
